import { APICompsSchema } from "@/apis/api-config";

import { AppFontSizeType, CurrentCellState, HighlightActiveState } from "@/types/common-types";
import { atom } from "jotai";

export const initializingAtom = atom<boolean>(true);
export const loadingAtom = atom<boolean>(false);
export const showSavingAtom = atom<boolean>(false);
export const dataGridLoadingAtom = atom<boolean>(false);
export const upOrDownKeyLongPressingAtom = atom<boolean>(false);

export const appFontTypeAtom = atom<AppFontSizeType>("large");

export const authTokenInfoAtom = atom<APICompsSchema["AuthTokenResponse"] | undefined>(undefined);
export const searchTextAtom = atom<string>("");
export const highlightActiveStateAtom = atom<HighlightActiveState | undefined>(undefined);
export const imeInputCellStateAtom = atom<CurrentCellState | undefined>(undefined);

// テーブル左端のIndex + Reorderの列の幅のAtom
export const tableLeftIndexWidthAtom = atom<number>(46);
